import React, { Suspense, lazy, useEffect } from "react";
import BaseLayout from "../layout/BaseLayout";
import "../styles/pages/home.scss";
import "../styles/pages/faq-offres.scss";

import { useLocation } from "react-router-dom";
import Intro from "../settings/home/Intro";
import MetaHome from "../meta/MetaHome";
import FAQOffres from "../components/divers/FAQOffres";

// const ProblemeSolution = lazy(() =>
//   import("../settings/home/ProblemeSolution")
// );
const Methode = lazy(() => import("../settings/home/Methode"));
const Prestations = lazy(() => import("../settings/home/Prestations"));
const Portfolio = lazy(() => import("../settings/home/Portfolio"));
const ChiffresCle = lazy(() => import("../settings/home/ChiffresCle"));
const Blog = lazy(() => import("../settings/home/Blog"));
const AvisClients = lazy(() => import("../settings/home/AvisClients"));
const Contact = lazy(() => import("../settings/home/Contact"));

export default function Home() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <MetaHome />
      <BaseLayout>
        <div className="home" id="home">
          <Intro />
          <div id="scroll-to-id"></div>

          <Suspense fallback={"<div>Loading...</div>"}>
            <Methode />
            {/* <ProblemeSolution /> */}
            {/* <Presentation /> */}
            <Prestations />
            <ChiffresCle />
            <Portfolio />
            <AvisClients />
            <section id="faq" className="mx-auto col-xxl-10">
              <h2 className="text-center">Questions fréquentes</h2>
              <FAQOffres
                question1="Est-ce que vous pouvez améliorer mon référencement sur Google ?"
                reponse1="Oui, grâce à mon offre de SEO local qui optimise vos mots-clés, votre fiche Google Business Profile et votre visibilité dans les résultats géolocalisés."
                question2="Quels résultats puis-je espérer avec le SEO local ?"
                reponse2="Plus de visibilité sur Google, plus d'appels, plus de visites en magasin ou sur votre site, et un meilleur taux de conversion local."
                question3="Combien de temps faut-il pour créer un site web professionnel ?"
                reponse3="En moyenne 2 à 4 semaines, selon la formule et la rapidité de transmission des contenus."
                question4="Proposez-vous vos services localement ou partout en France ?"
                reponse4="J'accompagne les indépendants, TPE et PME partout en France et en Belgique, tout en ayant une forte expérience sur le référencement local dans les Hauts-de-France."
                question5="Puis-je combiner création de site et SEO local ?"
                reponse5="Oui, mon pack complet démarre à 79 €/mois et permet d'avoir un site optimisé dès le départ, avec référencement local inclus."
              />
            </section>

            <Blog />
            <Contact />
          </Suspense>
        </div>
      </BaseLayout>
    </>
  );
}
